<mat-card *ngIf="file"
          class="smp-thumb-nail"
          [matTooltip]="getFileTitle()"
          [ngClass]="{'upload-error': file.thumbnailStatus === fileStatus.ERROR}">

  <mat-card-title class="thumb-nail-btn-container full-width">

    <button id="{{idPrefix}}btn.delete"
            mat-mini-fab
            class="smp-fab-btn smp-fab-btn-delete"
            [hidden]="!menuAvailable || !canDelete || !canDeleteDynamically() || disabled"
            (click)="deleteFile()">
      <mat-icon>clear</mat-icon>
    </button>

    <button id="{{idPrefix}}btn.download"
            mat-mini-fab
            class="smp-fab-btn smp-fab-btn-download"
            [ngClass]="{'only-btn': !canDelete }"
            [hidden]="!menuAvailable || !canDownload || disabled"
            (click)="downloadFile()">
      <mat-icon>get_app</mat-icon>
    </button>

    <button id="{{idPrefix}}btn.edit"
            mat-mini-fab
            class="smp-fab-btn smp-fab-btn-edit"
            [hidden]="!menuAvailable || !canEdit || disabled || !FileTypes.isEditableFileType(file.fileType)"
            (click)="editFile(file)">
      <mat-icon>edit</mat-icon>
    </button>

  </mat-card-title>

  <img id="{{idPrefix}}btn.show_image"
       *ngIf="file.thumbnailStatus === fileStatus.READY && file.fileType.category === fileCategory.PHOTO"
       [hidden]="!rendered"
       mat-card-image
       src="{{getReducedSizeFileLinkWithToken()}}"
       (click)="showFile()"
       (load)="loaded()">

  <i id="{{idPrefix}}btn.show_file"
     *ngIf="file.thumbnailStatus === fileStatus.READY && file.fileType.category !== fileCategory.PHOTO"
     class="dr-fa-icon far {{file.fileType.faClass}} fa-7x"
     (click)="showFile()">
  </i>

  <i *ngIf="file.thumbnailStatus === fileStatus.ERROR"
     class="dr-fa-icon far fa-file-excel fa-7x">
  </i>

  <mat-spinner *ngIf="file.thumbnailStatus === fileStatus.LOADING || (file.fileType && file.fileType.category === fileCategory.PHOTO && file.thumbnailStatus === fileStatus.READY && !rendered)" [diameter]="55"></mat-spinner>
</mat-card>

<div *ngIf="hasLabel" class="thumb-nail-label">{{ label }}</div>
